// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"6649d4e8","591":"2572ea1d","680":"67246305","900":"7a8d4a13"}[chunkId] + ".chunk.js";
};